"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = __importDefault(require("../../../_classes/component/editForm/utils"));
exports.default = [
    {
        key: 'labelPosition',
        ignore: true
    },
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'description',
        ignore: true
    },
    {
        key: 'hideLabel',
        ignore: false
    },
    {
        key: 'autofocus',
        ignore: true
    },
    {
        key: 'tooltip',
        ignore: true
    },
    {
        key: 'tabindex',
        ignore: true
    },
    {
        key: 'disabled',
        ignore: true
    },
    {
        weight: 85,
        type: 'checkbox',
        label: 'Hide when empty',
        tooltip: 'Hide when value is empty.',
        key: 'hideWhenEmpty',
        input: true
    },
    {
        type: 'select',
        key: 'align',
        label: 'Align',
        input: true,
        dataSrc: 'values',
        weight: 100,
        tooltip: 'Align.',
        data: {
            values: [
                { label: 'Left', value: 'justify-content-start' },
                { label: 'Center', value: 'justify-content-center' },
                { label: 'Right', value: 'justify-content-end' },
                { label: 'Full', value: 'justify-content-between' }
            ],
        },
    },
    {
        type: 'textarea',
        key: 'custom',
        label: 'Button Custom Logic',
        tooltip: 'The custom logic to evaluate when the button is clicked.',
        rows: 5,
        editor: 'ace',
        input: true,
        weight: 103,
        placeholder: "data['mykey'] = data['anotherKey'];",
        conditional: {
            json: { '===': [{ var: 'data.action' }, 'custom'] },
        },
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'theme',
        label: 'Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of buttons.',
    },
    {
        weight: 500,
        type: 'textfield',
        input: true,
        key: 'themeActive',
        label: 'Active Item Theme',
        placeholder: 'Item CSS Class',
        tooltip: 'The color theme of Active button.',
    },
];
